import React from 'react';
import { Form, Icon, Message, Divider } from 'semantic-ui-react'
import _find from 'lodash/find';
import {flowRight as compose} from 'lodash';
import {graphql} from 'react-apollo';
import queries from '../../../utils/queries'

import EstaSeguro from '../../../components/funcionales/estaseguro'


const ListaRealiz = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  console.log(permiteUpdate)
  console.log(idLista)
  console.log(argsDocum)
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="realizado" id="miLista7" value={permiteUpdate?argsDocum.realizado:idLista.alimSistema==='N'?'Seleccionar...':idLista.realizado==='S'?'Si':idLista.realizado==='N'?'No':'Seleccionar...'} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>Seleccionar...</option>
        <option>Si</option>
        <option>No</option>
      </select>
    </div>
  )
};


class VerProgRep2 extends React.Component {
  state={
    argsDocum: {realizado: this.props.idLista.alimSistema==='N'?'Seleccionar...':this.props.idLista.realizado?this.props.idLista.realizado==='S'?'Si':this.props.idLista.realizado==='N'?'No':'Seleccionar...':'Seleccionar...',
                ruta: this.props.idLista.ruta,
                numeroOrden: this.props.idLista.numeroOrden,
                cantidadReal: this.props.idLista.cantidadReal, descrUnidad: this.props.idLista.descrUnidad,
                minutosReal: this.props.idLista.minutosReal,
                observacionesReal: this.props.idLista.observacionesReal?this.props.idLista.observacionesReal:'',
                imgAntes: this.props.idLista.imgAntes?this.props.idLista.imgAntes:'',
                imgDespues: this.props.idLista.imgDespues?this.props.idLista.imgDespues:'',
                file: '', file1: ''
              },
    confirmaAct: false,
    open: false,
  }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      const argsDocum = this.state.argsDocum
      if(ev.target.name==='file' || ev.target.name==='file1'){
        let file = "", imgAntes = "", file1 = "", imgDespues = ""
        if(ev.target.name==='file'){
          file = ev.target.files[0]
          imgAntes = ev.target.files[0].name
          argsDocum['imgAntes'] = imgAntes
          argsDocum['file'] = file      
        }
        if(ev.target.name==='file1'){
          file1 = ev.target.files[0]
          imgDespues = ev.target.files[0].name
          argsDocum['imgDespues'] = imgDespues
          argsDocum['file1'] = file1      
        }
      }else{
        argsDocum[ev.target.name] = ev.target.value
      }
      this.setState({argsDocum});
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click() 
    }
  }
  
  render(){
    const {argsDocum, open, confirmaAct} = this.state;
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})

    let unidad='Cantidad de lub. (' + argsDocum.descrUnidad + ')'

    return(
      <div>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
            <div className="ui five column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '20%'}}>                
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    ruta: &nbsp;&nbsp;{this.props.idLista.ruta}
                  </p>                 
                </div>
                <div className="column" style={{width: '20%'}}>                
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    numeroOrden: &nbsp;&nbsp;{this.props.idLista.numeroOrden}
                  </p>                 
                </div>
                <div className="column" style={{width: '20%'}}>                
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Planta: &nbsp;&nbsp;{this.props.idLista.descrPlanta}
                  </p>                 
                </div>
                <div className="column" style={{width: '20%'}}>                
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Sección: &nbsp;&nbsp;{this.props.idLista.descrSeccion}
                  </p>                 
                </div>
                <div className="column" style={{width: '20%'}}>                
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Equipo: &nbsp;&nbsp;{this.props.idLista.descrEquipo}
                  </p>                 
                </div>
                
              </div>
            </div>
            <div className="ui five column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '20%'}}>                
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Componente: &nbsp;&nbsp;{this.props.idLista.descrComponente}
                  </p>                 
                </div>
                <div className="column" style={{width: '20%'}}>                
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Mecanismo: &nbsp;&nbsp;{this.props.idLista.descrMecanismo}
                  </p>                 
                </div> 
                <div className="column" style={{width: '20%'}}>                
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Tarea: &nbsp;&nbsp;{this.props.idLista.descrTarea}
                  </p>                 
                </div>  
                <div className="column" style={{width: '20%'}}>                
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Frecuencia: &nbsp;&nbsp;{this.props.idLista.descrFrecuencia}
                  </p>                 
                </div> 
                <div className="column" style={{width: '20%'}}>                
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Lubricante: &nbsp;&nbsp;{this.props.idLista.descrLubricante}
                  </p>                 
                </div>            
              </div>
            </div>

            <Divider inverted />

          <div className="ui three column stackable grid">
            <div className="row container">
              <div className="column" style={{width: "40%"}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Tarea ejecutada ?</label>
                  <ListaRealiz styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                </Form.Field>                
              </div> 
              <div className="column" style={{width: "30%"}}>
                <Form.Field>
                  <label style={this.props.styles.label}>{unidad}</label>
                  <Form.Input type='number' step="0.001" min="0" autoComplete="off" name="cantidadReal" id="cantidadReal" value={this.props.permiteUpdate?argsDocum.cantidadReal:this.props.idLista.cantidadReal?this.props.idLista.cantidadReal:0} onChange={this.handleChange} placeholder='Cantidad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'cantidadReal'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
              </div>
              <div className="column" style={{width: "30%"}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Minutos ejec.</label>
                  <Form.Input type='number' step="1" min="0" autoComplete="off" name="minutosReal" id="minutosReal" value={this.props.permiteUpdate?argsDocum.minutosReal:this.props.idLista.minutosReal?this.props.idLista.minutosReal:0} onChange={this.handleChange} placeholder='Minutos' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'minutosReal'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
              </div>          
            </div>
          </div>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '50%'}}>
                <Form.Field>
                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Seleccionar imagen antes de OT...&nbsp;&nbsp;
                    </label>
                    <input id="file" name="file" type="file" accept="image/*" style={estilos} onChange={this.handleChange}></input>
                </Form.Field> 
                </div>
                  <div className="column" style={{width: '50%'}}>
                  <Form.Field>
                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Seleccionar imagen después de OT...&nbsp;&nbsp;
                    </label>
                    <input id="file1" name="file1" type="file" accept="image/*" style={estilos} onChange={this.handleChange}></input>
                </Form.Field>  
              </div>
            </div>
          </div>
          <div className="ui one column stackable grid">
            <div className="row container">              
              <div className="column" width="100%">  
                <Form.Field>                
                  <label style={this.props.styles.label}>Observaciones</label>
                  <textarea name="observacionesReal" id="observacionesReal" cols="40" rows="3" onChange={this.handleChange}></textarea>                
                </Form.Field>
              </div>
            </div>
          </div>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default compose( 
  graphql(queries.mutation.fecha, {name:'fecha'}),
)(VerProgRep2)
